import Logo from '../../assets/logo.jpg';
import LoginCard from './components/LoginCard';


export default function Login() {
    


    return (
        <>
            <img src={Logo} className='w-[200px] absolute top-[8px] left-[8px]' alt='collaborations-pharma-logo'/>
            <div className='w-full h-screen bg-hero bg-cover flex justify-center items-center p-10'>
                    <LoginCard/>
            </div>
        </>
    )
}